"use client";
import React from "react";
import { Skeleton, Tabs } from "antd";
import { useSelector } from "react-redux";
import type { TabsProps } from "antd";
import Introduce from "./introduce";
import CommentStory from "./comment-story";
import ChaptersList from "./chapter-list";
import Review from "@/modules/review";
import { definitions } from "@/services/metruyenvl";
import { RootState } from "@/redux/store";

function MediaTabs({ slug }: { slug: string }) {
    const bookData = useSelector((state: RootState) => state.bookReducer?.map[slug]);

    const items: TabsProps["items"] = [
        {
            key: "1",
            label: `Giới thiệu`,
            children: <Introduce book={bookData?.detail} stats={bookData?.detail?.stats as definitions["do.StatsDO"]} />,
        },
        {
            key: "2",
            label: (
                <div className="flex items-center gap-x-1">
                    <div>Đánh giá</div>
                    {bookData?.detail?.stats ? <div className="p-2 bg-slate-100 rounded-full">{!!bookData?.detail?.stats?.reviews_count && bookData?.detail?.stats?.reviews_count > 0 ? bookData?.detail?.stats?.reviews_count : 0}</div> : <Skeleton.Avatar shape="circle" />}
                </div>
            ),
            children: <Review slug={slug} />,
        },
        {
            key: "3",
            label: (
                <div className="flex items-center gap-x-1">
                    <div>Danh sách chương</div>
                    {bookData?.detail?.stats ? <div className="p-2 bg-slate-100 rounded-full">{!!bookData?.detail?.stats?.chapters_count && bookData?.detail?.stats?.chapters_count > 0 ? bookData?.detail?.stats?.chapters_count : 0}</div> : <Skeleton.Avatar shape="circle" />}
                </div>
            ),
            children: <ChaptersList slug={slug} />,
        },
        {
            key: "4",
            label: (
                <div className="flex items-center gap-x-1">
                    <div>Bình luận</div>
                    {bookData?.detail?.stats ? <div className="p-2 bg-slate-100 rounded-full">{bookData?.detail?.stats?.comments_count ?? 0}</div> : <Skeleton.Avatar shape="circle" />}
                </div>
            ),
            children: <CommentStory slug={slug} />,
        },
    ];
    return (
        <div>
            <Tabs defaultActiveKey="1" items={items} tabBarStyle={{ color: "black", fontWeight: "600" }} size="large" className="p-2.5 mt-10 hidden lg:block" />
            <Tabs defaultActiveKey="1" items={items} tabBarStyle={{ color: "black", fontWeight: "600" }} size="small" className="p-2.5 mt-0 block lg:hidden" />
        </div>
    );
}

export default MediaTabs;
